import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCog, FaTimes, FaBars, FaPalette, FaIcons, FaSwatchbook } from 'react-icons/fa';

const Sidebar = ({ activeSection, setActiveSection, isMobileOpen, setIsMobileOpen }) => {
  const menuItems = [
    { id: 'general', label: 'General Settings', icon: FaCog },
    { id: 'navbar', label: 'Navbar Management', icon: FaPalette },
    { id: 'footer', label: 'Footer Management', icon: FaIcons },
    { id: 'colors', label: 'Website Colors', icon: FaSwatchbook },
    // Add more menu items here in the future
  ];

  const handleMenuClick = (id) => {
    setActiveSection(id);
    setIsMobileOpen(false); // Close mobile menu after selection
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        className="lg:hidden fixed top-20 left-4 z-50 p-3 bg-[#1a1a3e] border border-gray-700 rounded-lg text-white hover:border-purple-500 transition-colors"
      >
        {isMobileOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>

      {/* Overlay for mobile */}
      <AnimatePresence>
        {isMobileOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsMobileOpen(false)}
            className="lg:hidden fixed inset-0 bg-black/50 z-40"
          />
        )}
      </AnimatePresence>

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:sticky top-16 left-0 h-[calc(100vh-4rem)] 
          w-[280px] lg:w-full
          bg-[#1a1a3e] border-r border-gray-800 
          z-40 lg:z-0
          overflow-y-auto
          transition-transform duration-300 ease-in-out
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <div className="p-6">
          <h2 className="text-xl font-bold text-white mb-6">Admin Menu</h2>
          
          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeSection === item.id;
              
              return (
                <motion.button
                  key={item.id}
                  onClick={() => handleMenuClick(item.id)}
                  className={`
                    w-full flex items-center gap-3 px-4 py-3 rounded-xl
                    transition-all duration-200
                    ${isActive 
                      ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg' 
                      : 'text-gray-400 hover:bg-[#2a2a4e] hover:text-white'
                    }
                  `}
                  whileHover={{ scale: 1.02, x: 5 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Icon size={20} />
                  <span className="font-medium">{item.label}</span>
                  
                  {isActive && (
                    <motion.div
                      layoutId="activeIndicator"
                      className="ml-auto w-2 h-2 bg-white rounded-full"
                    />
                  )}
                </motion.button>
              );
            })}
          </nav>

          {/* Future Menu Items Placeholder */}
          <div className="mt-8 p-4 bg-[#0a0a1f] rounded-xl border border-gray-800">
            <p className="text-gray-500 text-sm text-center">
              More options coming soon...
            </p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
